export default "__VITE_ASSET__5b3fa0a9__"